import type { ValueOf } from 'type-fest';

import type { ItemsResponseBody } from './serverless-types/serverless-types';

export type {
  BaseUrlResponseBody as BaseUrlResponse,
  SitePagesItem,
} from './serverless-types/serverless-types';

export const sitePagesPageType = {
  blogPost: 'blogPost',
  staticPage: 'staticPage',
} as const;

export type SitePagesPageType = ValueOf<typeof sitePagesPageType>;

export type FetchSitePagesParams = {
  query?: string;
  paging?: {
    cursor?: string;
    limit?: number;
  };
};

export type FetchSitePages = (
  pageType: SitePagesPageType,
  params: FetchSitePagesParams
) => Promise<ItemsResponseBody>;
